import { IConfigKey } from '../../lib/loadOcppConfigKeys'
import findOcppConfig from '../../lib/findOcppConfig'

export const hasFeature = (feature: string, configKeys?: IConfigKey[]): boolean => {
    if (!configKeys) return false
    const config = findOcppConfig('SupportedFeatureProfiles', configKeys)

    if (!config) return false

    const features = config.split(',')
    if (features.find((r) => r === feature)) return true
    return false
}
